function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M46.8004 29C44.9004 29 43.1003 29.7 41.7003 31.1C40.4003 32.4 39.6003 34.3 39.6003 36.1H42.5004C42.5004 34.4 43.6003 32.8 45.2003 32.2C46.8003 31.5 48.6004 31.9 49.8004 33.1C51.0004 34.3 51.4003 36.2 50.7003 37.7C50.0003 39.3 48.5003 40.3 46.7003 40.3L19.9004 40.2V43.1L46.7003 43.2C49.3003 43.2 51.6004 41.9 52.9004 39.7C54.2004 37.5 54.2004 34.8 52.9004 32.5C51.7004 30.4 49.4004 29 46.8004 29Z",
  fill: "#BAA273"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M37.5 34.4001C37.6 33.0001 37.2 31.7001 36.3 30.7001C35.4 29.7001 34.1 29.1001 32.7 29.1001C31.3 29.1001 30 29.7001 29.1 30.7001C28.2 31.7001 27.7 33.0001 27.8 34.4001H30.7C30.7 33.6001 31.2 32.9001 31.9 32.6001C32.6 32.3001 33.5 32.5001 34 33.0001C34.6 33.6001 34.7 34.4001 34.4 35.1001C34.1 35.8001 33.4 36.3001 32.6 36.3001L20 36.2001V39.1001L32.6 39.2001C33.9 39.2001 35.1 38.7001 36 37.8001C37 37.0001 37.5 35.7001 37.5 34.4001Z",
  fill: "#BAA273"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M39.1 50.5C39.2 51.3 38.9 52.2 38.3 52.8C37.7 53.4 36.9 53.8 36.1 53.8C35.3 53.8 34.4 53.4 33.9 52.8C33.3 52.2 33.1 51.3 33.2 50.5H30.3C30.3 52.1 30.9 53.6 32 54.7C33.1 55.8 34.6 56.4 36.2 56.4C37.8 56.4 39.3 55.8 40.4 54.7C41.5 53.6 42.1 52.1 42.1 50.5C42.1 48.9 41.5 47.4 40.4 46.3C39.3 45.2 37.8 44.6 36.2 44.6L20 44.5V47.4L36.2 47.5C37.8 47.5 39.1 48.9 39.1 50.5Z",
  fill: "#BAA273"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M58.8 58.0999C58.1 58.0999 57.5 57.4999 57.5 56.7999V23.1999C57.5 22.4999 58.1 21.8999 58.8 21.8999C59.5 21.8999 60.1 22.4999 60.1 23.1999V56.7999C60.1 57.4999 59.5 58.0999 58.8 58.0999Z",
  fill: "#BAA273"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M40 3C60.4 3 77 19.6 77 40C77 60.4 60.4 77 40 77C19.6 77 3 60.4 3 40C3 19.6 19.6 3 40 3ZM40 0C17.9 0 0 17.9 0 40C0 62.1 17.9 80 40 80C62.1 80 80 62.1 80 40C80 17.9 62.1 0 40 0Z",
  fill: "#BAA273"
});

var SvgProtected = function SvgProtected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProtected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/protected.ec87f0ac.svg";
export { ForwardRef as ReactComponent };